import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M9.01 11.207H5.602a.2.2 0 0 1-.16-.32l5.589-7.41a.2.2 0 0 1 .36.12v5.196h3.408a.2.2 0 0 1 .16.32l-5.59 7.41a.2.2 0 0 1-.36-.12v-5.196Z" fill="currentColor" />' }
  })
);